// Redux
import { applyMiddleware, combineReducers, createStore } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import {thunk} from 'redux-thunk';

import { shop } from "./shop.reducer";
import { product } from "./product.reducer";

const persistConfig = {
  key: "solo-web",
  storage: storage,
  whitelist: [
    "shop", 
    "product"
  ]
};

// Middlewares
const middleware = () => {
  return applyMiddleware(thunk);
};


const pReducer = persistReducer(
  persistConfig,
  combineReducers({
    shop,
    product
  })
);

export default createStore(pReducer, middleware());